import { Injectable } from '@angular/core';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";

@Injectable({
  providedIn: 'root'
})
export class LcService {

  constructor() { }

  setLCRunning(isRunning: boolean) {
    localStorage.setItem("isLCRunning", "" + isRunning);
  }

  isLCRunning() {
    let isLCRunning: boolean = false;

    let isLCRunningStr: string = localStorage.getItem("isLCRunning");
    if (isNotNullOrUndefined(isLCRunningStr)) {
      if(isLCRunningStr == "true"){
        isLCRunning = true;
      }
    }

    return isLCRunning;
  }

  setLCDataAvailable(areLcDataAvailable: boolean) {
    localStorage.setItem("areLcDataAvailable", "" + areLcDataAvailable);
  }

  areLCDataAvailable() {
    let areLcDataAvailable: boolean = false;

    let areLcDataAvailableStr: string = localStorage.getItem("areLcDataAvailable");
    if (isNotNullOrUndefined(areLcDataAvailableStr)) {
      if(areLcDataAvailableStr == "true"){
        areLcDataAvailable = true;
      }
    }

    return areLcDataAvailable;
  }
}
